import { cn } from '@/lib/utils';
import type { SVGProps } from 'react';

export const Logo = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Logo"
    aria-hidden="true"
    className={cn('h-10 w-10', className)}
    {...props}
  >
    <rect
      width="512"
      height="512"
      rx="128"
      fill="url(#paint0_linear_4147_10)"
    />
    <g filter="url(#filter0_dii_4147_10)">
      <path
        d="M415.354 275.326C415.738 269.811 410.925 265.318 405.034 265.318L255.688 265.318C170.886 265.318 101.492 327.438 96.0215 405.992C95.6378 411.507 100.451 416 106.341 416L255.688 416C340.49 416 409.884 353.879 415.354 275.326Z"
        fill="url(#paint1_linear_4147_10)"
      />
      <path
        d="M415.979 106.009C416.362 100.494 411.55 96.0004 405.658 96.0004L256.312 96.0004C171.51 96.0004 102.116 158.121 96.6458 236.675C96.2622 242.19 101.075 246.683 106.966 246.683L256.312 246.683C341.114 246.683 410.508 184.562 415.979 106.009Z"
        fill="url(#paint2_linear_4147_10)"
      />
    </g>
    <defs>
      <filter
        id="filter0_dii_4147_10"
        x="95.2133"
        y="95.4759"
        width="321.573"
        height="321.573"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.262244" />
        <feGaussianBlur stdDeviation="0.393366" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4147_10"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4147_10"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.786732" />
        <feGaussianBlur stdDeviation="1.04898" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_4147_10"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.65561" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_4147_10"
          result="effect3_innerShadow_4147_10"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4147_10"
        x1="256"
        y1="-26.3719"
        x2="256"
        y2="523.578"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A897FF" />
        <stop offset="1" stop-color="#693EE0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4147_10"
        x1="415.376"
        y1="425.263"
        x2="95.6746"
        y2="425.263"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E6E6E6" />
        <stop offset="1" stop-color="#D6D6D6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4147_10"
        x1="416"
        y1="255.946"
        x2="96.299"
        y2="255.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#E6E6E6" />
      </linearGradient>
    </defs>
  </svg>
);
